<template>
  <button
    type="button"
    class="btn -white zoom-gallery-btn"
    aria-controls="productZoomGallery"
    :aria-expanded="productZoomGalleryOpen ? 'true' : 'false'"
    @click="openProductZoomGallery(index)"
    :aria-label="$t('(opens dialog)')"
  >
    <ZoomIcon />
  </button>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ZoomIcon from './ZoomIcon.vue'

export default {
  props: ['productZoomGalleryOpen', 'openProductZoomGallery', 'index'],
  name: 'ProductZoomGalleryButton',
  mixins: [ReadyHook],
  components: {
    ZoomIcon
  },

}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.zoom-gallery-btn {
  display: none;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 2;
  padding: 1rem;
  min-height: unset;

  @include bp(lg) {
    display: block;
    opacity: 0;
  }
}
</style>
